import { render } from "./DetalhePickingNova.vue?vue&type=template&id=47a2acbc&scoped=true"
import script from "./DetalhePickingNova.vue?vue&type=script&lang=js"
export * from "./DetalhePickingNova.vue?vue&type=script&lang=js"

import "./DetalhePickingNova.vue?vue&type=style&index=0&id=47a2acbc&scoped=true&lang=css"
import "./DetalhePickingNova.vue?vue&type=style&index=1&id=47a2acbc&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a2acbc"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QTable,QBtn,QCardSection,QSelect,QTd,QTooltip,QDialog,QCard,QField});
